import React from 'react';
import ReactDOM from 'react-dom';
import * as reactToastify from 'react-toastify';
import XLSX from 'xlsx';
import * as MobxReact from 'mobx-react';

window.React = React;
window.ReactDom = ReactDOM;
window.ReactRouter = require("react-router");
window.ReactRouterDom = require("react-router-dom");
window.ReactRouterConfig = require("react-router-config");
window.ReactToastify = reactToastify;
window.MaterialUI = require("@material-ui/core");
window.MaterialCoreStyles = require("@material-ui/core/styles");
window.MaterialIcons = require("@material-ui/icons");
window.MaterialPickers = require("@material-ui/pickers");
window.dateUtils = require("@material-ui/pickers/_helpers/date-utils");
window.XLSX = XLSX;
window.Mobx = require("mobx");
window.MobxReact = MobxReact;
